import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import styles from './Tag.module.css';

const bindClasses = classNameBind.bind(styles);

const Tag = ({
  id,
  children,
  color,
  isRemovable,
  isFocused,
  onRemove,
  noMargin,
  code,
  tabIndex,
  cutText,
  prominent,
  dataId,
  wordBreakingStyle,
}) => (
  <div
    className={bindClasses('tag', color, {
      isFocused,
      noMargin,
      cutText,
      prominent,
    })}
    data-ppuc-id={dataId}
  >
    <div
      className={bindClasses('name', { code }, wordBreakingStyle)}
      data-ppuc-id="Tag.name"
    >
      {children}
    </div>
    {isRemovable && (
      <div
        className={bindClasses('remove-button', color)}
        onClick={() => onRemove(id)}
        role="button"
        tabIndex={tabIndex}
        data-ppuc-id={`${dataId}.remove`}
      >
        <Icon name="cross" />
      </div>
    )}
  </div>
);

Tag.defaultProps = {
  id: undefined,
  color: 'gray',
  isRemovable: false,
  isFocused: false,
  onRemove: () => {},
  code: false,
  noMargin: false,
  tabIndex: 0,
  prominent: false,
  cutText: false,
  dataId: 'Tag',
  wordBreakingStyle: 'breakAll',
};

export { Tag };
